/**
 * NOTE: Ré-organiser tout ça proprement.
 * 
 * NOTE: Déporter toute la gestion d'animation dans un script séparé qu'on incluera
 * dans les scripts de blocks qui le nécessite.
 * 
 * @note L'objet wmuwpb est initialisé dans /includes/front/scripts.php
 */

/**
 * Document is loaded
 */
document.addEventListener( 'DOMContentLoaded', function()
{
	/**
	 * Create main ScrollTrigger instance
	 * 
	 * @see https://github.com/terwanerik/ScrollTrigger
	 */
	let scrollTrigger = new ScrollTrigger.default( {
		trigger: {
			offset: {},
			toggle: {
				class: {
					in: 'scroll-visible',
					out: 'scroll-invisible',
				},
			},
		},
		scroll: {
			sustain: 0,
		}
	} );

	const animeSettings = wmuwpb && wmuwpb.animate 
		? wmuwpb.animate
		: {
		'fade': {
			opacity: {
				value: [0, 1],
				duration: 500,
				easing: 'easeInOutQuad',
			},
			delay: 0,
		},
		'translate-x': {
			translateX: {
				value: [-400, 0],
				duration: 500,
			},
			opacity: {
				value: [0, 1],
				duration: 500,
				easing: 'easeInOutQuad',
			},
			delay: 0,
		}
	};

	const startViewport = wmuwpb.attributeSwitcher.currentViewport;
	const animeAttribute = startViewport.toLowerCase()+'-anime-type';

	const setAnime = ( targetAttribute ) => 
	{
		[].forEach.call( document.querySelectorAll( '[' + targetAttribute + ']' ), function ( element, index )
		{
			const animeType = element.getAttribute( targetAttribute );
			const animeSetting = animeSettings[animeType] ? animeSettings[animeType] : false;

			if ( !animeSetting ) {
				return;
			}
			
			let scrollTarget = element;
			
			scrollTrigger.add( scrollTarget, {
				toggle: {
					callback: {
						in: ( trigger ) => {
							anime( {
								targets: trigger.element,
								...animeSetting
							} );
						},
					}
				}
			} );
		} );
	}

	setAnime( animeAttribute );

	document.addEventListener( 'WMUViewportChange', ( event ) => 
	{
		const previousAnimeAttribute = event.detail.previousViewport.toLowerCase() + '-anime-type';
		const currentAnimeAttribute = event.detail.currentViewport.toLowerCase() + '-anime-type';

		let visibleClass = scrollTrigger.defaultTrigger.toggle.class.in;
		let invisibleClass = scrollTrigger.defaultTrigger.toggle.class.out;
		
		scrollTrigger.kill();
		document.querySelectorAll('[' + previousAnimeAttribute + ']').forEach((element) => {
			element.classList.remove(visibleClass);
			element.classList.remove(invisibleClass);
		});
		scrollTrigger.remove( '[' + previousAnimeAttribute + ']' );
		setAnime( currentAnimeAttribute );
		scrollTrigger.listen();
	} );
} );